// Sample product data organized by categories
export const productData = {
  kitchenware: {
    categoryName: 'Kitchenware',
    description: 'Eco-friendly bamboo kitchen essentials for sustainable cooking',
    products: [
      {
        id: 'ktw-001',
        name: 'Bamboo Chopping Board',
        price: '$29.99',
        image: '/images/kitchenware/chopping_board/chopping_board1.png',
        images: [
          '/images/kitchenware/chopping_board/chopping_board1.png',
          '/images/kitchenware/chopping_board/chopping_board2.png',
          '/images/kitchenware/chopping_board/chopping_board3.png'
        ],
        description: 'Durable bamboo cutting board with antibacterial properties. Perfect for all your food preparation needs.',
        features: ['Antibacterial', 'Dishwasher Safe', 'Sustainable', 'Natural finish']
      },
      {
        id: 'ktw-002',
        name: 'Bamboo Spoon Set',
        price: '$19.99',
        image: '/images/kitchenware/spoons/spoon1.png',
        images: [
          '/images/kitchenware/spoons/spoon1.png',
          '/images/kitchenware/spoons/spoon2.png',
          '/images/kitchenware/spoons/spoon3.png'
        ],
        description: 'Complete bamboo spoon set perfect for everyday cooking and serving. Lightweight and eco-friendly.',
        features: ['Travel Friendly', 'Lightweight', 'Natural finish', 'Eco-friendly']
      },
      {
        id: 'ktw-003',
        name: 'Bamboo Cutlery Stand',
        price: '$34.99',
        image: '/images/kitchenware/cutlerystand/cutlery_stand1.png',
        images: [
          '/images/kitchenware/cutlerystand/cutlery_stand1.png',
          '/images/kitchenware/cutlerystand/cutlery_stand2.png',
          '/images/kitchenware/cutlerystand/cutlery_stand_with_properties.png'
        ],
        description: 'Elegant bamboo cutlery stand that keeps your utensils organized and easily accessible.',
        features: ['Space-saving design', 'Stable construction', 'Easy cleaning', 'Natural design']
      },
      {
        id: 'ktw-004',
        name: 'Bamboo Spoon, Spatula & Turner Set',
        price: '$24.99',
        image: '/images/kitchenware/BambooSpoon,Spatula&Turnerset/BambooSpoon,Spatula&Turnerset.png',
        images: [
          '/images/kitchenware/BambooSpoon,Spatula&Turnerset/BambooSpoon,Spatula&Turnerset.png',
          '/images/kitchenware/BambooSpoon,Spatula&Turnerset/cutleries2.png',
          '/images/kitchenware/BambooSpoon,Spatula&Turnerset/spatulaspoon&turnerwithproperties.png'
        ],
        description: 'Complete bamboo cooking utensil set including spoon, spatula, and turner. Essential tools for every kitchen.',
        features: ['Complete set', 'Heat resistant', 'Natural finish', 'Kitchen essential']
      }
    ]
  },
  
  furniture: {
    categoryName: 'Furniture',
    description: 'Sustainable bamboo furniture for modern living spaces',
    products: [
      {
        id: 'fur-001',
        name: 'Bamboo Furniture Piece 1',
        price: '$149.99',
        image: '/images/furniture/furniture1_a.png',
        images: [
          '/images/furniture/furniture1_a.png',
          '/images/furniture/furniture1_b.png',
          '/images/furniture/furniture1_c.png'
        ],
        description: 'Elegant bamboo furniture piece that combines sustainability with modern design. Perfect for any living space.',
        features: ['Sustainable materials', 'Modern design', 'Durable construction', 'Natural finish']
      },
      {
        id: 'fur-002',
        name: 'Bamboo Furniture Piece 2',
        price: '$199.99',
        image: '/images/furniture/furniture2_a.jpg',
        images: [
          '/images/furniture/furniture2_a.jpg',
          '/images/furniture/furniture2_b.png',
          '/images/furniture/furniture2_c.png'
        ],
        description: 'Stylish bamboo furniture designed for functionality and aesthetics. Adds natural elegance to your home.',
        features: ['Functional design', 'Natural elegance', 'Sturdy construction', 'Versatile use']
      },
      {
        id: 'fur-003',
        name: 'Bamboo Furniture Piece 3',
        price: '$179.99',
        image: '/images/furniture/furniture3_a.png',
        images: [
          '/images/furniture/furniture3_a.png',
          '/images/furniture/furniture3_b.png',
          '/images/furniture/furniture3_c.png'
        ],
        description: 'Beautiful bamboo furniture piece crafted with attention to detail. Sustainable and stylish.',
        features: ['Handcrafted', 'Sustainable', 'Stylish design', 'Quality materials']
      },
      {
        id: 'fur-004',
        name: 'Bamboo Furniture Piece 4',
        price: '$159.99',
        image: '/images/furniture/furniture4_a.png',
        images: [
          '/images/furniture/furniture4_a.png',
          '/images/furniture/furniture4_b.png',
          '/images/furniture/furniture4_c.png'
        ],
        description: 'Premium bamboo furniture that enhances your living space with natural beauty and durability.',
        features: ['Premium quality', 'Natural beauty', 'Durable', 'Eco-friendly']
      }
    ]
  },

  homeDecoreGifts: {
    categoryName: 'Home Decore & Gifts',
    description: 'Beautiful bamboo home decor items and thoughtful gifts that enhance your living space with natural elegance',
    products: [
      {
        id: 'hdg-001',
        name: 'LeafLight Bamboo Planter Pendant Lamp – Hanging Bamboo & Rattan Cane Light',
        price: '$69.99',
        image: '/images/homedecore&gifts/ HD-1a.png',
        images: [
          '/images/homedecore&gifts/ HD-1a.png',
          '/images/homedecore&gifts/ HD-1b.png'
        ],
        description: 'Dual-purpose pendant lamp featuring a top light shade and bottom planter pot. Handcrafted from bamboo and rattan cane, it combines warm diffused lighting with nature, perfect for living rooms, dining corners, and cozy reading spaces. Easy weekly maintenance keeps your plants fresh and vibrant.',
        features: ['Dual-purpose design', 'Bamboo & rattan cane', 'Warm diffused light', 'Easy maintenance']
      },
      {
        id: 'hdg-002',
        name: 'Hibisca Bamboo Floor Lamp – Wooden Vintage Tripod Lamp',
        price: '$79.99',
        image: '/images/homedecore&gifts/ HD-2a.png',
        images: [
          '/images/homedecore&gifts/ HD-2a.png',
          '/images/homedecore&gifts/ HD-2b.png',
          '/images/homedecore&gifts/ HD-2c.png'
        ],
        description: 'A stunning blend of natural bamboo craft and vintage wood design. Features a handwoven bamboo shade inspired by floral curves, paired with a sturdy wooden tripod stand. Handcrafted by skilled artisans in Kerala, this lamp adds a warm, ambient glow while making a bold statement in living rooms, reading corners, and modern interiors.',
        features: ['Handwoven bamboo shade', 'Vintage wooden tripod', 'Floral-inspired design', 'Handcrafted in Kerala']
      },
      {
        id: 'hdg-003',
        name: 'Azura Twist Bamboo Cluster Light – Set of 3 Seashell 30D',
        price: '$89.99',
        image: '/images/homedecore&gifts/ HD-3a.png',
        images: [
          '/images/homedecore&gifts/ HD-3a.png',
          '/images/homedecore&gifts/ HD-3b.png',
          '/images/homedecore&gifts/ HD-3c.png'
        ],
        description: 'Three handcrafted pendant lamps inspired by seashell curves and Grand Canyon textures. Each shade is individually hand-coiled from sustainably sourced bamboo strips, suspended on a single base to create a stunning centerpiece. Brings warm, organic glow and artisanal charm to living rooms, dining areas, and café interiors.',
        features: ['Triple pendant cluster', 'Hand-coiled bamboo', 'Seashell-inspired design', 'Handcrafted in Kerala']
      },
      {
        id: 'hdg-004',
        name: 'Boca Minimal Bamboo Tabletop Test Tube Planter',
        price: '$99.99',
        image: '/images/homedecore&gifts/ HD-4a.png',
        images: [
          '/images/homedecore&gifts/ HD-4a.png',
          '/images/homedecore&gifts/ HD-4b.png',
          '/images/homedecore&gifts/ HD-4c.png',
          '/images/homedecore&gifts/ HD-4d.png'
        ],
        description: 'Eco-friendly tabletop planter handcrafted from premium bamboo. The bottle-shaped test tube design adds a modern twist to any decor, perfect for showcasing lucky bamboo or money plants. Compact and durable, ideal for desks, shelves, or window sills.',
        features: ['Handmade quality', 'Eco-friendly design', 'Modern bottle shape', 'Perfect for small plants']
      },
      {
        id: 'hdg-005',
        name: 'Minimal Oval Test Tube Wall Planter',
        price: '$84.99',
        image: '/images/homedecore&gifts/ HD-5a.png',
        images: [
          '/images/homedecore&gifts/ HD-5a.png',
          '/images/homedecore&gifts/ HD-5b.png',
          '/images/homedecore&gifts/ HD-5c.png'
        ],
        description: 'Sleek, space-saving wall planter crafted from durable bamboo. The unique curved design and transparent test tubes create a stunning visual display for your favorite plants or flowers. Low-maintenance and easy-to-install, perfect for urban living and busy lifestyles.',
        features: ['Space-saving design', 'Curved bamboo frame', 'Transparent test tubes', 'Easy installation']
      },
      {
        id: 'hdg-006',
        name: 'Bogen Bamboo Wood Test Tube Hanging Planter – Minimalist Plant Decor',
        price: '$94.99',
        image: '/images/homedecore&gifts/ HD-6a.png',
        images: [
          '/images/homedecore&gifts/ HD-6a.png',
          '/images/homedecore&gifts/ HD-6b.png',
          '/images/homedecore&gifts/ HD-6c.png',
          '/images/homedecore&gifts/ HD-6d.png'
        ],
        description: 'Perfect fusion of nature and craftsmanship. Features a gracefully curved bamboo arch and sturdy mahogany wooden base, holding a 50ml glass test tube. Ideal for displaying small plants or propagating cuttings. Handcrafted by skilled artisans, this minimalist hanging planter adds nature-inspired elegance to any home or office décor.',
        features: ['Curved bamboo arch', 'Mahogany wooden base', '50ml glass test tube', 'Perfect for money plants']
      }
    ]
  },

  lamps: {
    categoryName: 'Lamps',
    description: 'Elegant bamboo lamps that provide beautiful ambient lighting while adding natural elegance to your space',
    products: [
      {
        id: 'lamp-001',
        name: 'Onda Handmade Bamboo Pendant Lamp Shade Cluster of 3',
        price: '$129.99',
        image: '/images/lampshades/Lamp-1a.png',
        images: [
          '/images/lampshades/Lamp-1a.png',
          '/images/lampshades/Lamp-1b.png',
          '/images/lampshades/Lamp-1c.png',
          '/images/lampshades/Lamp-1d.png'
        ],
        description: 'Intricately woven by skilled women artisans from Kerala, this eco-friendly light fixture features a cluster of three pendants. The finely woven bamboo strips create soft, diffused lighting, combining traditional craftsmanship with modern design. Perfect for living rooms, dining areas, or bedrooms.',
        features: ['Handwoven by women artisans', 'Cluster of 3 pendants', 'Soft diffused light', 'Eco-friendly & sustainable']
      },
      {
        id: 'lamp-002',
        name: 'Lantova Rattan Cane Linear Light – L48 Long Chandelier 48 inch',
        price: '$139.99',
        image: '/images/lampshades/Lamp-2a.png',
        images: [
          '/images/lampshades/Lamp-2a.png',
          '/images/lampshades/Lamp-2b.png',
          '/images/lampshades/Lamp-2c.png',
          '/images/lampshades/Lamp-2d.png'
        ],
        description: 'Handcrafted long chandelier designed to blend earthy elegance with modern functionality. Meticulously woven from natural rattan and cane, this streamlined linear light offers balanced light distribution. Perfect for dining tables, kitchen countertops, cafés, restaurants, and breakfast counters.',
        features: ['48-inch linear design', 'Handmade rattan & cane', 'Perfect for dining spaces', 'Soft ambient glow']
      },
      {
        id: 'lamp-003',
        name: 'Viora – Handwoven Bamboo Pendant Light',
        price: '$119.99',
        image: '/images/lampshades/Lamp-3a.png',
        images: [
          '/images/lampshades/Lamp-3a.png',
          '/images/lampshades/Lamp-3b.png',
          '/images/lampshades/Lamp-3c.png'
        ],
        description: 'Sculptural bamboo pendant light handwoven by skilled women artisans from Kerala. Features soft, sculptural curves and breathable cane pattern that cast playful shadows and warm ambient glow. Made from 100% natural bamboo, lightweight and durable. Includes E27 holder, ceiling cap, wire, and adjustable 100cm hanging cord.',
        features: ['Handwoven by women artisans', '100% natural bamboo', 'Sculptural curves', 'E27 compatible']
      },
      {
        id: 'lamp-004',
        name: 'Bamboo Lamp CLA03',
        price: '$134.99',
        image: '/images/lampshades/CLA03.jpg',
        images: [
          '/images/lampshades/CLA03.jpg',
          '/images/lampshades/03 CLA03.jpg'
        ],
        description: 'Elegant bamboo lamp shade CLA03 that provides beautiful ambient lighting. Perfect for creating a warm and inviting atmosphere.',
        features: ['Ambient lighting', 'Elegant design', 'Natural materials', 'Energy efficient']
      },
      {
        id: 'lamp-005',
        name: 'Bamboo Lamp CLA06',
        price: '$144.99',
        image: '/images/lampshades/CLA06.1.jpg',
        images: [
          '/images/lampshades/CLA06.1.jpg',
          '/images/lampshades/06 CLA06.jpg'
        ],
        description: 'Beautiful bamboo lamp shade CLA06 with sophisticated design. Adds natural elegance to any room.',
        features: ['Sophisticated design', 'Natural elegance', 'Modern style', 'Sustainable']
      },
      {
        id: 'lamp-006',
        name: 'Bamboo Lamp CLA11',
        price: '$139.99',
        image: '/images/lampshades/CLA11.jpg',
        images: [
          '/images/lampshades/CLA11.jpg',
          '/images/lampshades/CLA11.1.jpg',
          '/images/lampshades/11 CLA11.jpg'
        ],
        description: 'Stylish bamboo lamp shade CLA11 designed to enhance your living space. Perfect for modern interiors.',
        features: ['Modern design', 'Stylish appeal', 'Quality construction', 'Versatile use']
      }
    ]
  }
};

export const getAllCategories = () => Object.keys(productData);
export const getCategoryProducts = (category) => productData[category]?.products || [];
export const getProductById = (productId) => {
  for (const category of Object.values(productData)) {
    const product = category.products.find(p => p.id === productId);
    if (product) return product;
  }
  return null;
};
